<template>
  <div class="tab-setting-detail">
    <div v-if="isActiveTitle" class="tab-setting-detail__title">
      Change phone number
    </div>
    <div class="tab-setting-detail__inputs">
      <b-row class="tab-setting-detail__input">
        <b-col cols="4" md="3" class="tab-setting-detail__input-label">
          <label>Phone number</label>
        </b-col>
        <b-col cols="8" md="9" class="tab-setting-detail__input-item tab-setting-detail__input-phone">
          <b-form-input readonly v-model="phoneNumber" />
          <!--<div class="tab-setting-detail__input-des">-->
            <!--A phone number will be sent to your new phone number address to verify its authenticity-->
          <!--</div>-->
        </b-col>
      </b-row>
    </div>
    <hr v-if="isActiveTitle">
    <!--<div class="tab-setting-detail__button">-->
      <!--<b-button>SUBMIT</b-button>-->
    <!--</div>-->
  </div>
</template>

<script>
import accountService from '@/services/account.service';
export default {
  props: {
    isActiveTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      phoneNumber: ''
    }
  },
  mounted() {
    accountService.myDetails().then((res) => {
      if (res) {
        this.phoneNumber = res.phone_number;
      }
    });
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/web/account/settings/_content.scss"/>
